<template>
  <div class="classify">
    <!-- 面包屑 -->
    <div class="position container yu_fc particles_box">
      <router-link to="/">首页</router-link>
      <i></i>
      {{title}}
    </div>
    <!-- 面包屑 -->
    <!-- banner -->
    <div class="banner container yu_fc particles_box" v-if="advertiseRotationListHomePage[0]">
      <img :src="advertiseRotationListHomePage[0].pic" />
    </div>
    <!-- banner -->
    <div class="boxs particles_box">
      <!-- 数据 -->
      <ul class="item_list">
        <template v-if="activityProductListHomePage[0]">
          <li v-for="(item, index) in activityProductListHomePage[0].activityProductResultList" :key="index+'a'">
            <a href="javascript:void(0)" class="img" @click="onGoodsDetail(item.productId,item.productSkuName)">
              <img :src="item.productPic" />
            </a>
            <a href="javascript:void(0)" class="title" @click="onGoodsDetail(item.productId,item.productSkuName)">{{item.productSkuName}}</a>
            <div class="price">
              <span>￥{{item.activityPrice}}</span>
              <del>￥{{item.originalPrice}}</del>
            </div>
          </li>
        </template>
        <template v-if="activityProductListHomePage[1]">
          <li v-for="(item, index) in activityProductListHomePage[1].activityProductResultList" :key="index+'b'">
            <a href="javascript:void(0)" class="img" @click="onGoodsDetail(item.productId,item.productSkuName)">
              <img :src="item.productPic" />
            </a>
            <a href="javascript:void(0)" class="title" @click="onGoodsDetail(item.productId,item.productSkuName)">{{item.productSkuName}}</a>
            <div class="price">
              <span>￥{{item.activityPrice}}</span>
              <del>￥{{item.originalPrice}}</del>
            </div>
          </li>
        </template>
        <template v-if="activityProductListHomePage[2]">
          <li v-for="(item, index) in activityProductListHomePage[2].activityProductResultList" :key="index+'c'">
            <a href="javascript:void(0)" class="img" @click="onGoodsDetail(item.productId,item.productSkuName)">
              <img :src="item.productPic" />
            </a>
            <a href="javascript:void(0)" class="title" @click="onGoodsDetail(item.productId,item.productSkuName)">{{item.productSkuName}}</a>
            <div class="price">
              <span>￥{{item.activityPrice}}</span>
              <del>￥{{item.originalPrice}}</del>
            </div>
          </li>
        </template>
        <template v-if="activityProductListHomePage[3]">
          <li v-for="(item, index) in activityProductListHomePage[3].activityProductResultList" :key="index+'d'">
            <a href="javascript:void(0)" class="img" @click="onGoodsDetail(item.productId,item.productSkuName)">
              <img :src="item.productPic" />
            </a>
            <a href="javascript:void(0)" class="title" @click="onGoodsDetail(item.productId,item.productSkuName)">{{item.productSkuName}}</a>
            <div class="price">
              <span>￥{{item.activityPrice}}</span>
              <del>￥{{item.originalPrice}}</del>
            </div>
          </li>
        </template>
        <template v-if="activityProductListHomePage[4]">
          <li v-for="(item, index) in activityProductListHomePage[4].activityProductResultList" :key="index+'3'">
            <a href="javascript:void(0)" class="img" @click="onGoodsDetail(item.productId,item.productSkuName)">
              <img :src="item.productPic" />
            </a>
            <a href="javascript:void(0)" class="title" @click="onGoodsDetail(item.productId,item.productSkuName)">{{item.productSkuName}}</a>
            <div class="price">
              <span>￥{{item.activityPrice}}</span>
              <del>￥{{item.originalPrice}}</del>
            </div>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import Bus from "../bus.js";
import { apiHomePageKyg, apiHomePageDyg, apiHomePageMqjp, apiHomePageNnby, apiHomePageSjpzy, apiHomePageMrbk, apiHomePagePthg, apiHomePageXsg, apiHomePageYhzx } from "@/api/index";
export default {
  name: "classify",
  data() {
    return {
      advertiseRotationListHomePage: [], // 轮播图
      activityProductListHomePage: [], // 活动商品
    };
  },
  created() {
    this.title = this.$route.query.name
    if (this.title == '康养馆') {
      this.homePageKyg()
    } else if (this.title == '地域精品') {
      this.homePageDyg()
    } else if (this.title == '名企精品') {
      this.homePageMqjp()
    } else if (this.title == '9.9包邮') {
      this.homePageNnby()
    } else if (this.title == '搜精品自营') {
      this.homePageSjpzy()
    }
  },
  methods: {
    // 康养馆
    async homePageKyg() {
      const res = await apiHomePageKyg()
      console.log("----------------------------------------------", res)
      if (res.code === 200) {
        this.activityProductListHomePage = res.data.activityProductListHomePage
        this.advertiseRotationListHomePage = res.data.advertiseRotationListHomePage
      }
    },
    // 地域精品
    async homePageDyg(){
      const res = await apiHomePageDyg()
      console.log(res)
      if (res.code === 200) {
        this.activityProductListHomePage = res.data.activityProductListHomePage
        this.advertiseRotationListHomePage = res.data.advertiseRotationListHomePage
      }
    },
    // 名企精品
    async homePageMqjp(){
      const res = await apiHomePageMqjp()
      console.log(res)
      if (res.code === 200) {
        this.activityProductListHomePage = res.data.activityProductListHomePage
        this.advertiseRotationListHomePage = res.data.advertiseRotationListHomePage
      }
    },
    // 9.9包邮
    async homePageNnby(){
      const res = await apiHomePageNnby()
      console.log(res)
      if (res.code === 200) {
        this.activityProductListHomePage = res.data.activityProductListHomePage
        this.advertiseRotationListHomePage = res.data.advertiseRotationListHomePage
      }
    },
    // 搜精品自营
    async homePageSjpzy(){
      const res = await apiHomePageSjpzy()
      console.log(res)
      if (res.code === 200) {
        this.activityProductListHomePage = res.data.activityProductListHomePage
        this.advertiseRotationListHomePage = res.data.advertiseRotationListHomePage
      }
    },
    // 商品详情
    onGoodsDetail(id, name) {
      let router = this.$router.resolve({
        path: "/goodsDetail",
        query: {
          id: id
        }
      });
      window.open(router.href, "_blank");
    }
  },
  watch: {},
  mounted() {}
};
</script>

<style lang="less" scoped>
.classify {
  padding-bottom: 60px;
  background: #f2f2f2;
}
// banner
.banner img {
  display: block;
  width: 1200px;
  height: 448px;
}
.boxs {
  width: 1200px;
  padding: 13px 40px 0;
  margin: 33px auto 0;
  overflow: hidden;
  background: #fff;
}
// 分类/排序
.class_sort {
  width: 100%;
  padding: 20px 0 6px;
  border-bottom: dashed 1px #dadada;
  overflow: hidden;
}
.class_sort .left {
  float: left;
  width: 78px;
  color: #999;
  font-size: 16px;
}
.class_sort .right {
  float: left;
  width: 1042px;
}
.class_sort .right span {
  float: left;
}
.class_sort .right span a {
  float: left;
  color: #333;
  font-size: 16px;
  margin: 0 32px 16px 0;
}
.class_sort .right span a.active,
.class_sort .right span a:hover {
  color: #c6b798;
}
.class_sort .right span a i {
  float: right;
  width: 11px;
  height: 14px;
  margin-left: 6px;
  position: relative;
}
.class_sort .right span a i::before,
.class_sort .right span a i::after {
  content: "";
  width: 11px;
  height: 6px;
  overflow: hidden;
  background-image: url("../assets/images/icon_0.png");
  background-repeat: no-repeat;
  position: absolute;
  left: 0;
}
.class_sort .right span a i::before {
  top: 0;
  background-position: -11px -141px;
}
.class_sort .right span a i::after {
  bottom: 0;
  background-position: -11px -147px;
}
.class_sort .right span a.active.ascn i::before {
  background-position: 0px -141px;
}
.class_sort .right span a.active.desc i::after {
  background-position: 0px -147px;
}
// 数据
.item_list {
  width: 1133px;
  min-height: 150px;
  padding-top: 20px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.item_list li {
  width: 270px;
  text-align: center;
  padding-bottom: 16px;
  margin-right: 13px;
  margin-bottom: 16px;
  overflow: hidden;
}
.item_list li:hover {
  background: rgba(244, 240, 234, 1);
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.1);
}
.item_list li.no_data {
  width: 100%;
  color: #333;
  font-size: 20px;
  font-weight: bold;
  line-height: 110px;
  padding: 0;
  margin: 0;
}
.item_list li.no_data:hover {
  background: #fff;
  box-shadow: 0 0 0 0px rgba(0, 0, 0, 0);
}
.item_list li .img,
.item_list li .img img {
  float: left;
  width: 270px;
  height: 270px;
}
.item_list li .label {
  float: left;
  width: 100%;
  font-size: 0;
  padding: 8px 0;
}
.item_list li .label span {
  color: #fff;
  height: 22px;
  line-height: 22px;
  padding: 0 3px;
  margin: 0 3px;
  background: #e36844;
  display: inline-block;
  vertical-align: top;
}
.item_list li .title {
  display: inline-block;
  color: #333;
  line-height: 1.2;
  max-width: 100%;
  margin-top: 16px;
  padding: 0 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.item_list li .title:hover {
  color: #b2a181;
}
.item_list li .price {
  font-size: 0;
  padding-top: 14px;
}
.item_list li .price span,
.item_list li .price del {
  display: inline-block;
  vertical-align: top;
}
.item_list li .price span {
  color: #da2833;
  padding-right: 6px;
}
.item_list li .price del {
  color: #999;
}
.item_list li hr {
  width: 143px;
  height: 1px;
  margin: 12px auto 17px;
  background: #dadada;
  overflow: hidden;
}
.item_list li p {
  color: #999;
  max-width: 100%;
  padding: 0 10px 26px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>